module.exports = __webpack_public_path__ + "14f4125cd91298091abb72a5a574205f.svg";